<template lang="pug">
div(v-if="hasId")
  slot(name="link" v-bind:showDetails="showDetails")
    button.btn.btn-default.btn-sm(@click.prevent="showDetails") Детали платежа
  regular-modal(:title="'Платеж в сети Tron' + (paymentId ? ': документ ' + paymentId : '')" width="600" ref="detailsModal").tron-payment-guess-modal
    .tron-payment-guess-modal--form
      dl
        dt ID платежа
        dd.selectable-text-all {{paymentId}}
        dt Может смайниться позже:
        dd
          template(v-if="result && !isLoading") {{result.canBeMinedLater ? 'Да' : 'Нет'}}
          template(v-if="isLoading") Загрузка...
          template(v-if="!isLoading && !result") &mdash;
        dt Tx ID
        dd.selectable-text-all
          template(v-if="isLoading") Загрузка...
          template(v-if="result && !isLoading") {{result.txid}}
          template(v-if="!isLoading && !result") &mdash;
        dt Tronscan
        dd.selectable-text-all
          template(v-if="isLoading") Загрузка...
          template(v-if="result && !isLoading")
            template(v-if="result.checkUrl")
              a(:href="result.checkUrl" target="_blank") {{result.checkUrl}}
            template(v-else)
              | &mdash;
          template(v-if="!isLoading && !result") &mdash;
        template(v-if="model.errors.has()")
          dt.error-row Ошибки загрузки
          dd.error-row
            model-errors-list(:errors="model.errors")

    template(v-slot:footer)
      .my-footer-buttons
        div
          button(type="button" @click.prevent="reload").btn.btn-default Обновить
        div
          button(type="button" @click.prevent="ok").btn.btn-success ОК

</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {TronPaymentGuess, TronPaymentGuessModel} from "@/backoffice/components/crypto/tron";
import RegularModal from "@/backoffice/components/modals/RegularModal.vue";
import BoErrorMessageBlock from "@/backoffice/legacy/mixins/regularforms/BoErrorMessageBlock.vue";
import ErrorModelHint from "@/backoffice/components/forms/ErrorModelHint.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import ModelErrorsList from "@/backoffice/legacy/mixins/regularforms/ModelErrorsList.vue";

@Component({
  name: "TronPaymentGuessModal",
  components: {ModelErrorsList, ErrorMessageBlock, ErrorModelHint, BoErrorMessageBlock, RegularModal}
})
export default class TronPaymentGuessModal extends Vue {
  @Prop({default: null})
  paymentId: string | number | null

  @Prop({default: false})
  investDocument: boolean

  result: TronPaymentGuess | null = null

  model = new TronPaymentGuessModel()

  get isLoading() {
    return this.model.loadingStatus.isLoading
  }

  reload() {
    this.result = null
    this.model.getPaymentGuess(this.paymentId, this.investDocument).then(result => {
      this.result = result
    })
  }

  showDetails() {
    this.reload();
    (this.$refs.detailsModal as RegularModal).showModal();
  }

  ok() {
    (this.$refs.detailsModal as RegularModal).hideModal();
  }

  get hasId() {
    return !!this.paymentId
  }
}
</script>

<style scoped lang="less">
.selectable-text-all {
  user-select: all;
}

.tron-payment-guess-modal {
  .my-footer-buttons {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
  }

  dl {
    .error-row {
      color: red;
    }
    margin-bottom: 0;
    display: grid;
    grid-gap: 5px 15px;
    grid-template-columns: 1fr 2fr;
    dt {
      padding: 1px 0;
    }
    dd {
      margin-left: 0;
      white-space: normal;
      word-break: break-all;
      padding: 1px 10px;
      &:hover {
        background-color: #f5f5f5;
      }
    }
  }
}
</style>
